import {getProfile} from '../../apis';
import {client} from '../../helpers/api';
import {isFunction} from '../../utils/Utils';
import {
  FORGOT_PASSWORD,
  SET_PROFILE,
  SET_TOKEN,
  SIGN_OUT,
} from '../reducers/auth';

import {getUniqueId} from 'react-native-device-info';
// import Notification from '../../helpers/Notification';
export function getAndSetProfile() {
  return async (dispatch, getState) => {
    const {profile: data} = await getProfile();
    dispatch({type: SET_PROFILE, payload: {data}});
    return data;
  };
}

export const signOut = () => {
  return (dispatch) =>
    client
      .post('/auth/signout', {deviceId: getUniqueId()})
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: SIGN_OUT,
          });
        }
      })
      .catch((err) => console.log('signout error', err));
};

export const signUp = (data, onSuccess, onFailure) => {
  return (dispatch) =>
    client
      .post('/auth/register', data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: SET_TOKEN,
            payload: {data: res.data.token},
          });
          if (isFunction(onSuccess)) {
            onSuccess();
          }
        } else {
          if (isFunction(onFailure)) {
            onFailure(res.data.message);
          }
        }
      })
      .catch((err) => {
        console.log('Sign up error', err);
        if (isFunction(onFailure)) {
          onFailure(err?.data?.message || err?.message || String(err));
        }
      });
};

export const signIn = (data, onSuccess, onFailure) => {
  return (dispatch) =>
    client
      .post('/auth/login', data)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: SET_TOKEN,
            payload: {data: res.data.token},
          });
          if (isFunction(onSuccess)) {
            onSuccess();
          }
        } else {
          if (isFunction(onFailure)) {
            onFailure(res.data.message);
          }
        }
      })
      .catch((err) => {
        console.log('Sign in error');
        if (isFunction(onFailure)) {
          onFailure(err?.data?.message || err?.message || String(err));
        }
      });
};

export const checkJWT = () => {
  return new Promise((resolve, reject) => {
    client
      .get('/auth/check')
      .then((res) => {
        if (res.data.status) {
          return resolve(res.data.data);
        }
        return reject(res.data.data);
      })
      .catch((err) => {
        console.log('jwt signIn failed');
        return reject(err?.data?.message || err?.message || String(err));
      });
  });
};

export const forgotPassword = (email, onSuccess, onFailure) => {
  return (dispatch) => {
    client
      .post('/auth/forgot-password', {email_id: email})
      .then((res) => {
        if (res.data.status) {
          if (isFunction(onSuccess)) {
            onSuccess(res.data);
          }
          dispatch({
            type: FORGOT_PASSWORD,
            payload: res.data,
          });
        } else {
          if (isFunction(onFailure)) {
            onFailure(res.data);
          }
        }
      })
      .catch((err) => {
        if (isFunction(onFailure)) {
          onFailure(err?.data?.message || err?.message || String(err));
        }
      });
  };
};
